import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import useSummaryUpdate from './useSummaryUpdate';

export default function useTicketsSelectionSummaryUpdate() {
  const ticketSelected = useSelector(
    (state) =>
      state.ticketsSelected.ids.map((id) => state.ticketsSelected.entities[id]),
    shallowEqual,
  );

  const promotions = useSelector((state) => state.promotions, shallowEqual);

  const { getDebouncedSummary } = useSummaryUpdate(
    'useTicketsSelectionSummaryUpdate',
  );

  useEffect(() => {
    getDebouncedSummary();
  }, [ticketSelected, promotions]);
}
